document.querySelectorAll('[data-lang]').forEach(root => {
  const btn = root.querySelector('.lang__btn'), form = root.querySelector('form'), input = form.querySelector('input[name="language_code"]');
  const set = o => { root.classList.toggle('is-open', o); btn.setAttribute('aria-expanded', o); };
  btn.addEventListener('click', e => { e.stopPropagation(); set(!root.classList.contains('is-open')); });
  root.querySelectorAll('.lang__opt').forEach(opt => opt.addEventListener('click', () => { input.value = opt.dataset.value; form.submit(); }));
  document.addEventListener('click', e => { if (!root.contains(e.target)) set(false); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') set(false); });
});
